/**
 * aswbe authorization eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';
import { AnaBizLogoutResponse } from '../model/anaBizLogoutResponse';
import { AswbeAuthorizationRequest } from '../model/aswbeAuthorizationRequest';
import { AswbeAuthorizationResponse } from '../model/aswbeAuthorizationResponse';
import { AuthorizationRequest } from '../model/authorizationRequest';
import { AuthorizationResponse } from '../model/authorizationResponse';
import { GetAnaBizContextResponse } from '../model/getAnaBizContextResponse';
import { GetCompanyAccountsResponse } from '../model/getCompanyAccountsResponse';
import { InitializeGoshokaiNetRequest } from '../model/initializeGoshokaiNetRequest';
import { InitializeGoshokaiNetResponse } from '../model/initializeGoshokaiNetResponse';
import { LogoutResponse } from '../model/logoutResponse';
import { RefreshAmcmemberBalanceResponse } from '../model/refreshAmcmemberBalanceResponse';
import { SelectCompanyAccountRequest } from '../model/selectCompanyAccountRequest';
import { SelectCompanyAccountResponse } from '../model/selectCompanyAccountResponse';
import { Type } from '../model/type';
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationApiService {
  protected basePath = 'http://localhost:8000';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * # 1. 概要 1. ANA Bizとしてのログインを行う。ANA Bizの企業ログインAPIを呼び出し、そのレスポンスをASWDB(Tx)のパーソナライズ情報のANA Bizログイン情報として保存する。    必要に応じてBE用認可APIのログインAPIを呼び出し、AMC会員ログインを行う。  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリング(API)(G01-010)を利用してMulesoftが生成したエラー情報を解析し、    ステータスコード400(Bad request)でエラー情報を返して、本処理を中止とする。 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。    有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。 1. 以下のいずれかに合致する場合、ステータスコード400(Bad request)でエラー情報を返して、本処理を中止とする。   1. 企業用パスワードが8～20文字以外、または半角英数字以外が含まれる (企業ログインの失敗と同じエラーコードとする)   1. AMC会員番号を上9桁の数字を7で割った余りに1を足した値が、下1桁と一致しない (AMCログインの失敗と同じエラーコードとする)   1. AMC用パスワードが8～16文字以外、または半角英数字以外が含まれる (AMCログインの失敗と同じエラーコードとする) 1. リクエストパラメータの「企業IDまたは組織ID」と企業用パスワード、リクエストパラメータの管理者IDが指定された場合は管理者IDをパラメータに加えてANA Biz APIの企業ログインAPIを呼び出す。 1. 企業ログインAPIから返却された企業ログイン認証情報の結果区分が認証失敗の場合、ステータスコード400(Bad request)でエラー情報を返して、本処理を中止とする。 1. リクエストパラメータの接続区分がシームレスの場合、以下のパラメータ整合性チェックを行い、条件に一致する場合はステータスコード400(Bad request)でエラー情報を返して、本処理を中止とする。   1. リクエストパラメータで指定された企業用管理コード1～3が、半角英数字、かつ、10桁以内であること。   1. リクエストパラメータで指定された企業用管理コード4が、60桁以内であること。 ※文字種チェックは行わない   1. リクエストパラメータのデータ連携送信フラグが指定されているが、リクエストパラメータのデータ連携送信先URL、      データ連携送信形式のいずれかが未設定、またはリクエストパラメータのデータ連携送信先URLのプロトコルが「https」以外の場合。   1. リクエストパラメータで指定された搭乗予定日(往路、復路)が以下のいずれかを満たす     1. yyyyMMdd形式でない     1. 有効な日付でない     1. 過去日である 1. 以下の企業ログイン認証チェックを行い、いずれかの条件に一致する場合はステータスコード400(Bad request)でエラー情報を返して、本処理を中止とする。   1. 企業ログイン認証情報の利用開始日が未設定   1. 企業ログイン認証情報の利用開始日&gt;操作日(JST)   1. 企業ログイン認証情報のアカウント失効日(※)≦操作日(JST)      ※ 解約日+13カ月の日付で、アカウントが完全解約とみなされる日   1. 企業ログイン認証情報の契約形態がパーチェシング型契約以外かつ、ログイン種別が企業精算単位でログイン   1. 企業ログイン認証情報のイントラネット接続限定フラグが「限定されている」、かつリクエストパラメータの接続区分が「シームレス」でない   1. 企業ログイン認証情報のシームレス接続フラグが「使用しない」、かつリクエストパラメータの接続区分が「シームレス」である   1. 管理者ログインかつ、企業ログイン認証情報が以下を全て満たす      ※ 全体管理者の場合はチェック対象の項目が値なしとなるため、部門管理者の場合のチェックとなる。     1. 以下いずれかを満たす         1. 管理者権限フラグが0(権限無し)         1. 契約ステータス(管理対象企業精算CD)が値なし、契約中以外         1. アカウント失効日(管理対象企業精算CD)≦操作日(JST)     1. 以下いずれかを満たす         1. 承認者権限フラグが0(権限無し)         1. 契約ステータス(承認対象企業精算CD)が値なし、契約中以外         1. アカウント失効日(承認対象企業精算CD)≦操作日(JST) 1. 企業ログイン認証情報のログイン種別が「企業単位でログイン」かつ契約形態がパーチェシング型契約の場合を除き、企業CD、企業精算CD、契約形態、    個別設定フラグ(契約形態がパーチェシング型契約の場合のみ(設定値はC票情報の企業精算個別設定を使用)を指定してANA Biz APIの企業情報取得処理(企業用管理コード取得)を呼び出し、企業用管理コード情報を取得する。 1. 部門管理者でログイン(管理者ログインかつ、企業ログイン認証情報の管理対象企業精算CDが存在する)した場合、管理対象企業精算Cを指定してANA Biz APIの企業情報取得処理(C票情報の取得)を呼び出し、    C票情報を取得する。C票情報が存在しない場合、ステータスコード400(Bad request)でエラー情報を返して、本処理を中止とする。 1. リクエストパラメータのAMC会員番号とAMC用パスワードがどちらも指定されている場合、リクエストパラメータのAMC会員番号とAMC用パスワード、AMC自動ログインフラグをパラメータとして    BE用認可APIを呼び出す。BE用認可APIから以下いずれかのエラーが返却された場合、ステータスコード400(Bad request)でエラー情報を返して、本処理を中止とする。   1. AMC会員番号が存在しない、またはパスワード間違い   1. MINDSから返却された処理結果がアカウントロック   1. MINDSから返却された処理結果が同時接続数制限 1. 指定されたリクエストパラメータ、企業ログイン認証情報、管理対象企業情報を基にASWDB(Tx)のパーソナライズ情報を更新する。 1. 管理者ログインの場合、企業ログイン認証情報の企業IDおよび管理ユーザIDを基にANA Biz APIの管理ユーザ最終ログイン日時更新処理APIを呼び出す。 1. 以下の項目を含むCookieを作成する。    ※Cookieは項目毎に暗号化し、暗号化方式はBlowfish暗号化(エンコードUTF-8)＋BASE64エンコード(エンコードUTF-8)とする。   1. hasBizCompanyCookie     1. 法人情報クッキー保存有無:リクエストパラメータの企業ID保存有無の指定がない場合はfalse、それ以外はリクエストパラメータの企業ID保存有無。   1. hasBizCompanyCookiePassword     1. 法人情報クッキーパスワード保存有無:リクエストパラメータのパスワード保存有無の指定がない場合はfalse、それ以外はリクエストパラメータのパスワード保存有無。   1. company2     1. ロール:パーソナライズ情報のANA Bizログイン情報のロールリスト。     1. ログインID:リクエストパラメータの企業ID保存有無に永続化するが指定された場合、リクエストパラメータの企業IDまたは組織ID。     1. ログイン使用パスワード:リクエストパラメータのパスワード保存有無に永続化するが指定された場合、リクエストパラメータの企業用パスワード。     1. 管理者ユーザID:リクエストパラメータの企業ID保存有無に永続化するが指定された場合、リクエストパラメータの管理者ID。 1. 企業ログイン認証情報のログイン種別が1(企業単位でログイン)かつ契約形態がパーチェシング型契約の場合を除き、以下の内容でcompanyRealのCookieを作成する。    当処理は【ANA Biz companyReal Cookie作成処理】とする。    ※Cookieは暗号化し、暗号化方式はBlowfish暗号化(エンコードUTF-8)＋BASE64エンコード(エンコードUTF-8)とする。   1. 有効期限:現在時刻に設定ファイルに定義した有効期限を加算した値。   1. 発券要求件数:法人情報の認証情報の企業CDをパラメータとしてANA Biz APIの発券要求取得APIを呼び出し、取得した発券要求数。 1. ステータスコード200(正常)を返却する。  # 3. データ更新内容 1. ASWDB(Tx) |更新テーブル|更新内容|データ取得元|条件等| |:---|:---|:---|:---| | パーソナライズ情報  | 1.ユーザ共通.ANA Bizログインステータス&lt;br&gt;2.ANA Bizログイン情報について以下&lt;br&gt;2-1.接続区分&lt;br&gt;2-2.ログイン使用ユーザID&lt;br&gt;2-3.ログイン使用管理者ユーザID&lt;br&gt;2-4.認証情報について以下&lt;br&gt;2-4-1.企業ログインAPIのレスポンス項目&lt;br&gt;2-4-2.企業情報(A票)&lt;br&gt;2-4-3.企業精算情報(C票)&lt;br&gt;2-4-4.管理対象企業情報(C票)&lt;br&gt;2-4-5.企業管理コード情報&lt;br&gt;2-4-6.ロールリスト&lt;br&gt;2-5.シームレス接続情報 | 1.企業ログイン認証情報のログイン種別が「企業単位でログイン」、かつ契約形態がパーチェシング型契約の場合は組織選択必要、それ以外はログイン済み&lt;br&gt;2.ANA Bizログイン情報について以下&lt;br&gt;2-1.リクエストパラメータ&lt;br&gt;2-2.リクエストパラメータ&lt;br&gt;2-3.リクエストパラメータ&lt;br&gt;2-4.認証情報について以下&lt;br&gt;2-4-1.企業ログインAPIのレスポンス項目&lt;br&gt;2-4-2.企業ログインAPIのレスポンス項目&lt;br&gt;2-4-3.ANA Bizログインステータスがログイン済みの場合のみ、企業ログインAPIのレスポンス項目&lt;br&gt;2-4-4.部門管理者でログインした場合のみ、管理対象企業情報(C票)&lt;br&gt;2-4-5.ANA Bizログインステータスがログイン済みの場合のみ、企業管理コード情報&lt;br&gt;2-4-6.以下の条件に一致する値を複数設定する。&lt;br&gt;TRAVELERは必ず設定する&lt;br&gt;管理者ログイン、かつ企業ログイン認証情報の承認者権限フラグが権限ありの場合、APPROVER&lt;br&gt;管理者ログイン、かつ企業ログイン認証情報の管理対象企業精算CDの値がある場合、DEPARTMENT_ADMINISTRATOR&lt;br&gt;管理者ログイン、かつ企業ログイン認証情報の管理対象企業精算CDの値がない場合、COMPANY_ADMINISTRATOR&lt;br&gt;2-5.リクエストパラメータの接続区分が通常の場合は値なし、接続区分がシームレスの場合はリクエストパラメータ | - |  1. ANA BizDB (ANA Biz API経由で登録) |更新テーブル|更新内容|データ取得元|条件等| |:---|:---|:---|:---| | 管理者情報  | 管理ユーザ最終ログイン日時 | 現在日時(JST) | 管理者ログインの場合 |  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public anaBizAuthorizationPost(
    generated?: AuthorizationRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<AuthorizationResponse>;
  public anaBizAuthorizationPost(
    generated?: AuthorizationRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<AuthorizationResponse>>;
  public anaBizAuthorizationPost(
    generated?: AuthorizationRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<AuthorizationResponse>>;
  public anaBizAuthorizationPost(
    generated?: AuthorizationRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/ana-biz/authorization`;
    return this.httpClient.request<AuthorizationResponse>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 1. アクセストークンのuuidをキーにASWDB(Tx)のパーソナライズ情報よりANA Bizログイン情報を取得する。  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリング(API)(G01-010)を利用してMulesoftが生成したエラー情報を解析し、    ステータスコード400(Bad request)でエラー情報を返却する。 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。    有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。 1. 認可検証APIより返却されたuuidを基に、ASWDB(Tx)からパーソナライズ情報を取得する。 1. ユーザ共通情報のANA Bizログインステータスがログイン済み以外の場合、ステータスコード400(Bad request)でエラー情報を返して、本処理を中止とする。  # 3. データ更新内容 なし    # 4. 特記事項 ANABizログイン時に作成するcompanyReal Cookieの存在チェックについては本APIの呼び出し元側で実施するものとし、本APIでは実施しない前提とする。
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public anaBizGetAnaBizContextGet(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<GetAnaBizContextResponse>;
  public anaBizGetAnaBizContextGet(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<GetAnaBizContextResponse>>;
  public anaBizGetAnaBizContextGet(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<GetAnaBizContextResponse>>;
  public anaBizGetAnaBizContextGet(
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/ana-biz/get-ana-biz-context`;
    return this.httpClient.request<GetAnaBizContextResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 1. パラメータを基にANA Biz組織リストを返却する。  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリング(API)(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。 1. 認可検証APIより返却されたuuidを基に、ASWDB(Tx)からパーソナライズ情報を取得する。 1. パーソナライズ情報のユーザ共通情報のANA Bizログインステータスが組織選択必要以外の場合、ステータスコード400(Bad request)でエラー情報を返却する。 1. パーソナライズ情報のANA Bizログイン情報の、認証情報の企業CDを指定してANA Biz APIの組織一覧取得処理を呼び出し、組織リストを取得する。 1. ステータスコード200(正常)を返却する。  # 3. 特記事項 以下のいずれかの条件に当てはまる組織はANA Biz APIから回答されないため、考慮不要とする。 1. 利用開始日が未設定 1. 利用開始日&gt;操作日 1. アカウント失効日≦操作日
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public anaBizGetCompanyAccountsPost(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<GetCompanyAccountsResponse>;
  public anaBizGetCompanyAccountsPost(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<GetCompanyAccountsResponse>>;
  public anaBizGetCompanyAccountsPost(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<GetCompanyAccountsResponse>>;
  public anaBizGetCompanyAccountsPost(
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/ana-biz/get-company-accounts`;
    return this.httpClient.request<GetCompanyAccountsResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要 1. ASWDB(Tx)のSパーソナライズ情報のANA Bizログインステータスを未ログインに更新、およびANABizログイン情報の削除を行う。ANABizログイン時に作成したCookieの削除も行う。  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリング(API)(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。 1. 認可検証APIのレスポンスのuuidをキーとし、ASWDB(Tx)の保存したANABizログインに関連する情報の削除を行う。         1. ANABizログイン時に作成した以下のCookieの削除を行う。           1. 企業ID保存有無(hasBizCompanyCookie)           1. パスワード保存有無(hasBizCompanyCookiePassword)           1. 有効期限、発券要求件数(companyReal)           1. ロール、ログインID、ログイン使用パスワード、管理者ユーザID(company2)         1. ステータスコード200(正常)を返却する。  # 3. データ更新内容 1. ASWDB(Tx) |更新テーブル|更新内容|データ取得元|条件等| |:---|:---|:---|:---| | S2パーソナライズ情報 | 1.ANA Bizログインステータス&lt;br&gt;2.ANA Bizログイン情報 | 1.NOT_LOGIN：未ログイン&lt;br&gt;2.値なし | - |  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public anaBizLogoutPost(
    generated?: object,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<AnaBizLogoutResponse>;
  public anaBizLogoutPost(
    generated?: object,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<AnaBizLogoutResponse>>;
  public anaBizLogoutPost(
    generated?: object,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<AnaBizLogoutResponse>>;
  public anaBizLogoutPost(
    generated?: object,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/ana-biz/logout`;
    return this.httpClient.request<AnaBizLogoutResponse>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 1. パラメータで指定した企業精算CDに紐づく企業情報(C票)を、ASWDB(Tx)のパーソナライズ情報のANA Bizログイン情報に登録し、ユーザ共通のANA Bizログインステータスをログイン済みに変更する。  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリング(API)(G01-010)を利用してMulesoftが生成したエラー情報を解析し、    ステータスコード400(Bad request)でエラー情報を返却する。 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。    有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。 1. 認可検証APIより返却されたuuidを基に、ASWDB(Tx)からパーソナライズ情報を取得する。 1. パーソナライズ情報のユーザ共通のANA Bizログインステータスが組織選択必要以外の場合、ステータスコード400(Bad request)でエラー情報を返却する。 1. リクエストパラメータの企業精算CDを指定してANA Biz APIの企業情報取得処理(C票情報の取得)を呼び出し、C票情報を取得する。C票情報が存在しない場合、ステータスコード400(Bad request)でエラー情報を返却する。 1. リクエストパラメータの企業精算CD、パーソナライズ情報のANA Bizログイン情報の企業CD、契約形態、個別設定フラグ(設定値は企業情報取得処理(C票情報の取得)にて取得したC票情報の企業精算個別設定を使用)を指定して    ANA Biz APIの企業情報取得処理(企業用管理コード取得)を呼び出し、企業用管理コード情報を取得する。 1. ASWDB(Tx)のパーソナライズ情報に以下の更新を行う。   1. ANA Bizログイン情報のC票情報に、取得したC票情報を追加   1. ユーザ共通のANA Bizログインステータスをログイン済みに更新 1. ANA Biz ログインAPIの【ANA Biz comapnyReal Cookie作成処理】を呼び出し、Cookieを作成する。 1. ステータスコード200(正常)を返却する。  # 3. データ更新内容 1. ASWDB(Tx) |更新テーブル|更新内容|データ取得元|条件等| |:---|:---|:---|:---| | パーソナライズ情報 | 1.ユーザ共通のANA Bizログインステータス&lt;br&gt;2.ANA Bizログイン情報の企業精算情報(C票)&lt;br&gt;3.ANA Bizログイン情報の企業管理コード情報 | 1.ログイン済み(固定)&lt;br&gt;2.ANA Biz APIのレスポンス&lt;br&gt;3.ANA Biz APIのレスポンス | - |  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public anaBizSelectCompanyAccountPost(
    generated?: SelectCompanyAccountRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<SelectCompanyAccountResponse>;
  public anaBizSelectCompanyAccountPost(
    generated?: SelectCompanyAccountRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<SelectCompanyAccountResponse>>;
  public anaBizSelectCompanyAccountPost(
    generated?: SelectCompanyAccountRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<SelectCompanyAccountResponse>>;
  public anaBizSelectCompanyAccountPost(
    generated?: SelectCompanyAccountRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/ana-biz/select-company-account`;
    return this.httpClient.request<SelectCompanyAccountResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要 1. ASW BEとしてのログインを行う。S1 認可APIのSSOログインAPIを呼び出し、必要に応じてMindsから会員情報を取得し、ASWDB(Tx)のS2パーソナライズ情報の会員情報に情報を保存する。  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリングAPI(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。 1. リクエストパラメータの搭乗者に含まれているかチェック要否、マイル減算者の会員かチェック要否のいずれかに必要が指定された場合は、以下の処理で指定されたチェックを行う。   1. リクエストパラメータの予約番号と搭乗者姓、搭乗者名を基に作成したcredentialファイル情報をパラメータとしてPNR情報取得APIを呼び出す。   1. PNR情報取得APIから返却されたPNR情報に対して、以下のチェックを行い条件に一致しない場合、ステータスコード400(Bad request)でエラー情報を返却する。     1. 搭乗者に含まれているかチェック要否に必要が指定された場合、会員PNRで航空券の支払手段にGMOPを含むか判定する。     1. マイル減算者の会員かチェック要否に必要が指定された場合、特典PNRでマイル減算者の会員か判定する。 1. リクエストパラメータの会員番号とパスワード、自動ログインフラグをパラメータとしてS1 SSOログインAPIを呼び出す。リクエストパラメータに会員番号がない場合は、認可検証APIのレスポンスのuuidをキーとしASWDB(Tx)S2パーソナライズ情報の会員情報の会員番号を利用する。 1. S1SSOログインAPIからエラーが返却された場合、返却されたエラーを以下の単位で当処理のエラーとし、ステータスコード400(Bad request)でエラー情報を返却する。   1. AMC会員番号が存在しない、またはパスワード間違い   1. MINDSから返却された処理結果がアカウントロック   1. MINDSから返却された処理結果が同時接続数制限   1. 上記以外のエラーが発生 1. S1SSOログインAPIを呼び出した時の会員番号をパラメータとしてMindsより会員情報ならびにSKYコイン残高を取得する。 ※ S1で作成しているシステムAPI(会員データ(参照)API)を利用する。 ※ SSOログインでリアルログインした場合、S1パーソナライズにMindsから取得した最新情報が入るが、S1パーソナライズ情報にはS2で必要な会員情報がすべて入っていないため、S2として別途でMindsにアクセスする必要がある。 1. Mindsから取得した会員情報のカードステータスがアクティブ会員(親会員または単独)でない場合、ステータスコード401(Unauthorized)でエラー情報を返却する。 1. 会員情報、SKYコイン残高を基にASWDB(Tx)S2パーソナライズ情報の会員情報とユーザ共通情報のログインステータスを更新する。 1. ステータスコード200(正常)を返却し処理を終了する。  # 3. データ更新内容 1. ASWDB(Tx)のS2パーソナライズ情報   1. ユーザ共通情報の項目について以下の内容を更新する。 |更新フィールド|更新内容|データ取得元|条件等| |:---|:---|:---|:---| |ユーザ共通情報のログインステータス|リアルログイン|||    1. 会員情報の項目については会員データ(参照)APIの戻り値で更新する。    # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public aswbeAuthorizationPost(
    generated?: AswbeAuthorizationRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<AswbeAuthorizationResponse>;
  public aswbeAuthorizationPost(
    generated?: AswbeAuthorizationRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<AswbeAuthorizationResponse>>;
  public aswbeAuthorizationPost(
    generated?: AswbeAuthorizationRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<AswbeAuthorizationResponse>>;
  public aswbeAuthorizationPost(
    generated?: AswbeAuthorizationRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/aswbe-authorization`;
    return this.httpClient.request<AswbeAuthorizationResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要 1. ご紹介ねっとからの流入処理として、リクエストで指定された紹介者情報をASWDB(Tx)S2パーソナライズ情報のユーザ共通情報に保持する処理である。  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリングAPI(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。 1. レスポンスのuuidをキーとしASWDB(Tx)S2パーソナライズ情報を取得し、ユーザ共通情報のご紹介ねっと情報を、呼び出し元より渡されたご紹介ねっと情報に更新する。 1. ステータスコード200(正常)を返却し処理を終了する。  # 3. データ更新内容 1. ASWDB(Tx)のS2パーソナライズ情報 |更新フィールド|更新内容|データ取得元|条件等| |:---|:---|:---|:---| |ユーザ共通情報のご紹介ねっと経由識別|true||| |ユーザ共通情報のご紹介ねっと紹介番号|ご紹介ねっと紹介番号|呼び出し元より渡された情報|| |ユーザ共通情報のご紹介ねっと紹介者名(姓)|ご紹介ねっと紹介者名(姓)|呼び出し元より渡された情報|| |ユーザ共通情報のご紹介ねっと紹介者名(名)|ご紹介ねっと紹介者名(名)|呼び出し元より渡された情報||    # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public initializeGoshokaiNetPost(
    generated?: InitializeGoshokaiNetRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<InitializeGoshokaiNetResponse>;
  public initializeGoshokaiNetPost(
    generated?: InitializeGoshokaiNetRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<InitializeGoshokaiNetResponse>>;
  public initializeGoshokaiNetPost(
    generated?: InitializeGoshokaiNetRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<InitializeGoshokaiNetResponse>>;
  public initializeGoshokaiNetPost(
    generated?: InitializeGoshokaiNetRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/initialize-goshokai-net`;
    return this.httpClient.request<InitializeGoshokaiNetResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要 1. ASW BEとしてのログアウトを行う。S1 認可APIのログアウトを呼び出し、ASWDB(Tx)のS2パーソナライズ情報のユーザ共通情報のログインステータスを未ログインに更新、および会員情報をクリアする。  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリングAPI(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。 1. S1 ログアウトAPIを呼び出す。 1. リクエストパラメータの会員番号とパスワード、自動ログインフラグをパラメータとしてS1 SSOログインAPIを呼び出す。リクエストパラメータに会員番号がない場合は、認可検証APIのレスポンスのuuidをキーとしASWDB(Tx)S2パーソナライズ情報の会員情報の会員番号を利用する。 1. S1SSOログインAPIからエラーが返却された場合、返却されたエラーを以下の単位で当処理のエラーとし、ステータスコード400(Bad request)でエラー情報を返却する。 1. 認可検証APIのレスポンスのuuidをキーとし、ASWDB(Tx)S2パーソナライズ情報の更新を行う。 1. ステータスコード200(正常)を返却し処理を終了する。   # 3. データ更新内容 1. ASWDB(Tx)のS2パーソナライズ情報 |更新フィールド|更新内容|データ取得元|条件等| |:---|:---|:---|:---| |ユーザ共通情報のログインステータス|未ログイン||  |会員情報|値なし|||   # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public logoutPost(
    generated?: object,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<LogoutResponse>;
  public logoutPost(
    generated?: object,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<LogoutResponse>>;
  public logoutPost(
    generated?: object,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<LogoutResponse>>;
  public logoutPost(
    generated?: object,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/logout`;
    return this.httpClient.request<LogoutResponse>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 1. ASWDB(Tx)S2パーソナライズ情報の会員情報のSKYコイン残高、マイル残高、アップグレードポイントを最新化する。  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリングAPI(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。 1. S1 認可検証APIのレスポンスのuuidをキーとして、ASWDB(Tx)S2パーソナライズ情報を取得する。 1. パーソナライズ情報のユーザ共通情報のログインステータスがリアルログイン以外の場合、 ステータスコード400(Bad request)でエラー情報を返却する。 1. S2パーソナライズ情報の会員情報の会員番号をパラメータとしてMindsよりSKYコイン残高、マイル残高、アップグレードポイントを取得する。 ※ S1で作成しているシステムAPI(会員データ(参照)API)を利用する。 1. 会員情報のSKYコイン残高、マイル残高、アップグレードポイントを、Mindsより取得したSKYコイン残高、マイル残高、アップグレードポイントで上書きし、認可検証APIのレスポンスのuuidをキーとしASWDB(Tx)のS2パーソナライズ情報を更新する。 1. ステータスコード200(正常)を返却し処理を終了する。  # 3. データ更新内容 1. ASWDB(Tx)のS2パーソナライズ情報 |更新フィールド|更新内容|データ取得元|条件等| |:---|:---|:---|:---| |会員情報のマイル残高|残マイル|S1で作成しているシステムAPI(会員データ(参照)API)のレスポンス|integer型に変換| |会員情報のマイル残高（AFAグループ）|マイル残高（AFAグループ）|S1で作成しているシステムAPI(会員データ(参照)API)のレスポンス|integer型に変換| |会員情報のSKYコイン残高|ANAｅクーポン合計数|S1で作成しているシステムAPI(会員データ(参照)API)のレスポンス|integer型に変換| |会員情報のアップグレードポイント数残高（今年度）|アップグレードポイント数残高（今年度）|S1で作成しているシステムAPI(会員データ(参照)API)のレスポンス|integer型に変換| |会員情報のアップグレードポイント数残高（次年度）|アップグレードポイント数残高（次年度）|S1で作成しているシステムAPI(会員データ(参照)API)のレスポンス|integer型に変換|    # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public refreshAmcmemberBalancePost(
    generated?: object,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<RefreshAmcmemberBalanceResponse>;
  public refreshAmcmemberBalancePost(
    generated?: object,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<RefreshAmcmemberBalanceResponse>>;
  public refreshAmcmemberBalancePost(
    generated?: object,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<RefreshAmcmemberBalanceResponse>>;
  public refreshAmcmemberBalancePost(
    generated?: object,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/refresh-amcmember-balance`;
    return this.httpClient.request<RefreshAmcmemberBalanceResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
